import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-org-dossier-tabs',
  templateUrl: './org-dossier-tabs.component.html'
})

export class OrgDossierTabsComponent {
  @Input() selectedEntityId: String;
  @Input() selectedEntityType: String;
}



// WEBPACK FOOTER //
// ./src/app/entities/org-dossier-tabs.component.ts